import React, { useEffect, useState } from "react";
import { Mail, Phone } from "lucide-react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";
import EnquiryForm from "@/components/public/EnquiryForm";
import { useSite } from "@/context/SiteContext";

const CATEGORIES = [
  "General", "Partnership", "Supplier", "Investment/Acquisition Opportunity",
  "Media", "Careers", "Venture Enquiry",
];

export default function Contact() {
  const { settings } = useSite();
  const [ventures, setVentures] = useState([]);
  useEffect(() => { api.get("/ventures").then(({ data }) => setVentures(data)).catch(() => {}); }, []);

  return (
    <div data-testid="page-contact" className="bg-bd-black min-h-screen">
      <section className="pt-40 pb-16 grain relative">
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-bd-gold mb-6">Contact</p>
            <h1 className="font-serif text-4xl md:text-7xl text-bd-ivory leading-[1.05] max-w-4xl">
              Begin a conversation with the group
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-bd-charcoal">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <Reveal>
              <h2 className="font-serif text-3xl text-bd-ivory mb-6">Direct enquiries</h2>
              <p className="text-bd-ivory/55 leading-relaxed mb-8 text-sm">
                Select the most relevant category and we will route your enquiry to the right part of the group.
              </p>
              <div className="space-y-5">
                {settings.contact_email && (
                  <a href={`mailto:${settings.contact_email}`} className="flex items-center gap-3 text-bd-ivory/70 hover:text-bd-gold transition-colors">
                    <Mail size={18} strokeWidth={1.5} className="text-bd-gold" /> {settings.contact_email}
                  </a>
                )}
                {settings.phone && (
                  <span className="flex items-center gap-3 text-bd-ivory/70">
                    <Phone size={18} strokeWidth={1.5} className="text-bd-gold" /> {settings.phone}
                  </span>
                )}
              </div>
              <div className="mt-10 pt-8 border-t border-white/10 text-sm text-bd-ivory/40">
                <p>{settings.company_name || "Black Diamond Ventures Group Ltd"}</p>
                <p>Company No. {settings.company_no || "17369044"}</p>
                {settings.registered_office && <p className="mt-2">{settings.registered_office}</p>}
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <div className="bg-bd-black border border-white/10 p-8 md:p-12">
                <EnquiryForm
                  dark
                  category="General"
                  categories={CATEGORIES}
                  showCompany showPhone
                  showVenture ventures={ventures}
                  showAttachment
                  submitLabel="Send Enquiry"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
